<template>
  <v-col cols="12" md="3">
    <v-hover v-slot="{ hover }">
      <v-card :elevation="hover ? 12 : 2" @click="open" class="mx-auto">
        <v-overlay :value="stock === 0" absolute color="#E00000">
          <p class="text-h5 font-weight-light">Nicht auf Lager</p>
        </v-overlay>

        <v-img
          :src="src"
          height="180"
          width="100%"
          contain
          class="white--text"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        >
          <v-card-title class="fill-height align-end pa-0 ma-0">
            <v-chip v-if="live" color="green" text-color="white" class="ma-2" label>
              Live
            </v-chip>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" class="product-title text-truncate">
                  {{ title }}
                </v-col>
              </v-row>
              <v-row v-if="price || acdPrice" no-gutters align="center" justify="center">
                <v-chip v-if="price" class="ma-1" small>
                  Preis: {{ formatPrice(price) }} €
                </v-chip>
                <v-chip v-if="acdPrice" class="ma-1" small>
                  ACD Preis: {{ formatPrice(acdPrice) }} €
                </v-chip>
              </v-row>
            </v-container>
          </v-card-title>
        </v-img>

        <v-card-text>
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="auto" class="pr-3">
              Lagerbestand:
            </v-col>
            <v-col>
              <v-progress-linear
                :value="stockPercentage"
                :color="stockColor"
                height="25"
                rounded
              >
                <template v-slot:default="{ value }">
                  <strong>{{ stock }}</strong>
                </template>
              </v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>
  </v-col>
</template>

<script>
export default {
  name: "ProductCard",
  props: {
    id: [Number, String],
    title: String,
    src: String,
    description: String,
    stock: Number,
    price: Number,
    acdPrice: Number,
    live: Boolean,
  },
  computed: {
    stockPercentage() {
      return Math.min((this.stock / 200) * 100, 100);
    },
    stockColor() {
      if (this.stock > 200) return 'green';
      if (this.stock > 100) return 'yellow';
      if (this.stock > 50) return 'orange';
      return 'red';
    }
  },
  methods: {
    formatPrice(price) {
      return (price / 100).toFixed(2);
    },
    open() {
      console.log(`Produkt mit ID ${this.id} wurde angeklickt`);
    },
  },
};
</script>

<style scoped>
.product-title {
  font-size: 1.1em;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>